import script from "./AddVehicleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddVehicleModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddVehicleModal.vue?vue&type=style&index=0&id=2c69b993&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c69b993"]])

export default __exports__